import type { OrderbookItem } from '@/types/otc'

export interface TrendingAssetsBaseProps {
  /**
   * `OrderbookItem` rather than `TrendingAsset` so the strip can be fed from
   * either source. `/orderbook/trending` has no non-financial counterpart, so
   * a session without verification is shown rows from `/orderbook/public`
   * instead — real companies, no amounts. `TrendingAsset` is assignable to
   * this type, so nothing changes for a verified caller.
   */
  assets: OrderbookItem[]
  onAssetClick?: (asset: OrderbookItem) => void
  loading?: boolean
  /**
   * Overrides the heading. Set when the rows are NOT a trending ranking —
   * calling an unranked slice of the order book "Trending Assets" would state
   * something the data does not support.
   */
  title?: string
  /** The session is not entitled to amounts — draw the lock, not an em dash. */
  financialsHidden?: boolean
}

export const DEFAULT_TRENDING_TITLE = 'Trending Assets'

/**
 * See `OrderbookTableContentDesktop.isGated`. The caller's tier decides; the
 * row's own flag is the backstop; a merely-absent amount at `full` tier is
 * missing data, not withheld data.
 */
export const isAssetAmountGated = (
  asset: { financials_hidden?: boolean },
  financialsHidden: boolean,
): boolean => financialsHidden || asset.financials_hidden === true

export const getTypeColor = (dealType: string): string => {
  switch (dealType) {
    case 'LIQUID_TOKEN':
      return '#2ea66b' // Green
    case 'SAFT':
      return '#ac5bdb' // Purple
    case 'EQUITY':
      return '#3481ec' // Blue
    default:
      return 'rgba(45,41,35,0.72)'
  }
}

